import {ImageInterface} from 'app/types/ImageInterface';
import VideoClubInterface from 'app/components/tv/models/VideoClubInterface';

export default class VideoClub {
  id: number;
  name: string;
  middleName: string;
  shortName: string;
  image: ImageInterface;
  slug: string;

  constructor(data: VideoClubInterface) {
    Object.assign(this, data);
  }
}
